import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

export interface PillButtonProps {
  to?: string;
  onClick?: () => void;
  label: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  'aria-label'?: string;
  'data-testid'?: string;
}

export const PillButton: React.FC<PillButtonProps> = ({
  to,
  onClick,
  label,
  icon,
  iconPosition = 'left',
  className,
  type = 'button',
  disabled = false,
  'aria-label': ariaLabel,
  'data-testid': testId,
}) => {
  const iconElement = icon ? (
    <span className={styles.icon}>{icon}</span>
  ) : null;

  const content = iconPosition === 'left' ? (
    <>
      {iconElement}
      <span className={styles.label}>{label}</span>
    </>
  ) : (
    <>
      <span className={styles.label}>{label}</span>
      {iconElement}
    </>
  );

  const combinedClassName = [
    styles.pillButton,
    iconPosition === 'right' ? styles.iconRight : '',
    !icon ? styles.noIcon : '',
    className || '',
  ].filter(Boolean).join(' ');

  if (to) {
    return (
      <Link to={to} className={combinedClassName} data-testid={testId}>
        {content}
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={combinedClassName}
      type={type}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {content}
    </button>
  );
};

export default PillButton;
